import {ProductsStockGridState} from './types';

export const initialState: ProductsStockGridState = {
  display: 'quantity',
  expandedCollections: {},
  expandedFamilies: {},
  expandedProducts: {},
};
